module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-copyright u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container-small c-marg--before-footer u-relative"
  }, [_c('header', {
    staticClass: "u-relative u-pad-l-md u-pad-l-0@lg u-pad-b-xl c-small-title"
  }, [_c('h1', {
    staticClass: "t-h4 u-uppercase"
  }, [_vm._v(_vm._s(_vm.contentPage.title))]), _vm._v(" "), _c('div', {
    staticClass: "u-absolute u-pos-bl u-fit-w u-height-2 c-small-title__border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "o-content u-marg-t-xl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.content)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "u-relative u-fit-w u-marg-t-xxl u-marg-x-auto u-align-center"
  }, [_c('app-btn', {
    attrs: {
      "to": _vm.contentGlobal.taxonomies.footer.contact.link.url
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.actions.contactUs)
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c5a3d02"}!./src/scripts/components/page-copyright/template.html
// module id = 925
// module chunks = 0